import {React, Component} from "react";

export default class Footer extends Component {
render(){
    return(

        <> {/* ======= Footer ======= */}
        {/* <footer id="footer" className="footer">
          <div className="copyright">
            © Copyright <strong><span>Xtrava</span></strong>. All Rights Reserved
          </div>
        </footer> */}
        {/* End Footer */}</>
    );}}